import { CART } from "./apiURl";
import { commonHeaders, getRequest, postRequest } from "./httpHelper";

export const getCartAPI = async (payload = {}) => {
  const {
    photo_id: photoId = null,
    event_id: eventId = null,
    access_id: accessId = null,
    language = "fr"
  } = payload;

  let url = `${CART}`;

  const queryParams = new URLSearchParams();

  if (eventId) queryParams.append("event_id", eventId);
  if (accessId) queryParams.append("access_id", accessId);
  if (photoId) queryParams.append("photo_id", photoId);
  if (language) queryParams.append("lang", language);

  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`;
  }

  try {
    const response = await getRequest({
      url: url,
      headers: commonHeaders
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const postCartAPI = async (data) => {
  try {
    const response = await postRequest({
      url: `${CART}`,
      headers: commonHeaders,
      data: data
    });
    return response.data;
  } catch (error) {
    return null;
  }
};
